import * as bootstrap from 'bootstrap'
import i18next from 'i18next';

/**
 * Generates popovers for specified header elements and appends them.
 *
 * @param {string} header_class - The class of the header elements where the popovers will be appended.
 * @param {Object} exp_map - A mapping object containing explanations for each header element.
 */
export function gen_popover(header_class, exp_map) {
    const titles = document.querySelectorAll(header_class);

    titles.forEach(item => {
        const icon = document.createElement("i");
        icon.className = "bi bi-question-circle text-success info_icon";

        const exp_popover = document.createElement("a");
        exp_popover.role = "button";
        exp_popover.className = "btn mb-3 info_btn";
        exp_popover.setAttribute("tabindex", "0");
        exp_popover.setAttribute("data-bs-toggle", "popover");
        exp_popover.setAttribute("data-bs-trigger", "focus");
        exp_popover.setAttribute("data-bs-placement", "right");
        exp_popover.setAttribute("data-bs-custom-class", "custom-popover")
        exp_popover.setAttribute("data-bs-title", i18next.t("info"));
        exp_popover.setAttribute("data-bs-content", i18next.t(item.id));
        
        exp_popover.appendChild(icon);
        item.appendChild(exp_popover);
    })
    //$(titles).localize();
    // init Popover
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl);
    });

    return popoverList;
}